import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useHospitalReviewList } from "../../../../api/member-management/use-hospital-review";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import { useSetState } from "../../../../utils/hooks";
import Navigation from "../Components/navigation";
import { HospitalReviewTable } from "./Section/hospital-review-table";
import HospitalReviewFilter from "./Section/HospitalReviewFilter";

const searchOptions = [
  { id: "productGroupName", name: "관련 상품명" },
  { id: "contents", name: "내용" },
];

export const HospitalDetailReviewPage = () => {
  const [filter, dispatchFilter] = useSetState();
  const { id } = useParams();
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [sort, dispatchSort] = useSetState();

  const { isEmpty, getDataTableProps } = useHospitalReviewList(
    selectedFilter,
    id,
    sort
  );

  const [changeSearchBy, setChangeSearchBy] =
    React.useState("productGroupName");
  const [mode, setMode] = useState("ALL");
  const toggleMode = (selectedMode) => {
    setMode(selectedMode);
    setSelectedFilter({ ...filter, division: selectedMode });
  };

  const onChangeSearchBy = (val) => {
    setChangeSearchBy(val);
  };

  const onSubmitFilter = () => {
    setSelectedFilter(filter);
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setChangeSearchBy("productGroupName");
  };
  return (
    <>
      <TitlePage title="회원조회 > 회원상세" />
      <Navigation id="review" hospitalId={id} />
      <div className="mt-8">
        {!isEmpty && (
          <>
            <HospitalReviewFilter
              onChangeSearchBy={onChangeSearchBy}
              onFilter={dispatchFilter}
              options={searchOptions}
              onSubmitFilter={onSubmitFilter}
              onResetFilter={onResetFilter}
              searchBy={changeSearchBy}
            />
            <div className="flex mt-8">
              <div
                onClick={() => toggleMode("ALL")}
                className={`cursor-pointer w-[120px] h-8 flex justify-center items-center ${
                  mode === "ALL"
                    ? "bg-primary-blue text-white"
                    : "text-[#999999] border border-[#dddddd]"
                } p-[5px]`}
              >
                전체
              </div>
              <div
                onClick={() => toggleMode("PHOTO")}
                className={`cursor-pointer w-[120px] h-8 flex justify-center items-center ${
                  mode === "PHOTO"
                    ? "bg-primary-blue text-white"
                    : "text-[#999999] border border-[#dddddd]"
                } p-[5px]`}
              >
                포토 리뷰
              </div>

              <div
                onClick={() => toggleMode("GENERAL")}
                className={`cursor-pointer w-[120px] h-8 flex justify-center items-center ${
                  mode === "GENERAL"
                    ? "bg-primary-blue text-white"
                    : "text-[#999999] border border-[#dddddd]"
                } p-[5px]`}
              >
                일반 리뷰
              </div>
            </div>
          </>
        )}
        <HospitalReviewTable
          isEmpty={isEmpty}
          getDataTableProps={getDataTableProps}
          onSort={dispatchSort}
        />
      </div>
    </>
  );
};
